import React from 'react';
import ReactDOM from 'react-dom/client';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';
import './index.css';
import App from './App';
import { initAnalytics, analytics } from './analytics';

window.onscroll = e => {
  const y = window.scrollY;
  const stageY = document.getElementById("stage")?.getBoundingClientRect().y + y;
  const taskY = document.getElementById("task")?.getBoundingClientRect().y + y;
  if (!stageY || !taskY) return;
  document.getElementById("nav-item-task").classList[y >= taskY ? "add" : "remove"]("selected");
  document.getElementById("nav-item-stage").classList[y >= stageY && window.scrollY < taskY ? "add" : "remove"]("selected");
  document.getElementById("nav-item-query").classList[y < stageY ? "add" : "remove"]("selected");
  document.getElementById("nav").style.top = (y < 103 ? 103 - y : -3) + "px";
}

window.VERSION = window.VERSION || await fetch('version').then(res => res.text()).then(text => text.trim());

// Web analytics (SPD-23855) — HubSpot loader is injected async and no-ops off
// the production domain / in the wamini embed. Core Web Vitals are forwarded to
// the same provider (statically imported so the wamini single-file build inlines
// them instead of emitting a separate chunk).
initAnalytics();
const reportVital = (metric) => analytics.webVital(metric.name, metric.value);
getCLS(reportVital); getFID(reportVital); getFCP(reportVital); getLCP(reportVital); getTTFB(reportVital);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
